import React from 'react';
import './FSA.css';

import Icon from '../../../components/Icon/Icon';

const fsa = ( props ) => (
	<section id="FSA" className="section">
		<div className="inner-section">
			<p>
				Flexible Spending Account (FSA) signup is every December for the following calendar year (January 1-December 31). If you've never had one of these accounts, it basically allows you to save pre-tax money to use for eligible medical expenses (e.g., deductibles, prescriptions, copays). 
			</p>
			<p>
				You decide how much you want to put aside for the year, and the pro-rated amount is automatically deducted from each paycheck. The maximum allowable expense is $2,550 for individual employees and $5,000 for employees with dependents. The full amount you choose is available to use immediately on January 1. Calculate carefully, because you can't roll over any remaining money at the end of the year!
			</p>
		</div>
		<Icon icon="benefits.fsa" gradient="vertical" title="Piggy Bank" />
	</section>
);

export default fsa;



// WEBPACK FOOTER //
// ./src/pages/Benefits/FSA/FSA.js